import ActionTypes from "../actions/ActionTypes";

const initialState = {
  driverServices: [],
  exclusiveDriverServices: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_EXCLUSIVE_DRIVER_SERVICES:
      return {
        ...state,
        exclusiveDriverServices: action.payload,
      };
    case ActionTypes.SET_DRIVER_SERVICES:
      return {
        ...state,
        driverServices: action.payload,
      };
    default:
      return state;
  }
}
